module.exports = __webpack_public_path__ + "static/media/check_small.1386f2a7.svg";